import gql from "graphql-tag";

/**
 * Schematics:
 * addType
 * updateType
 * deleteType
 */



/******************************
 * LOGIN / REGISTER / MIGRATE
 ******************************/

export const login = gql`
mutation login($name: String!, $password: String!) {
	login(name: $name, password: $password)
}`;

export const loginOld = gql`
mutation loginOld($name: String!, $password: String!) {
	loginOld(name: $name, password: $password) 
}`;

export const loginMagic = gql`
mutation loginMagic($token: String!) {
	loginMagic(token: $token) 
}`;

export const requestMagic = gql`
mutation requestMagic($handle: String!) {
	requestMagic(handle: $handle) 
}`;

export const migrateUser = gql`
mutation migrateUser($token: String!, $id: ID!, $name: String!, $password: String!, $phone: String, $email: String, $birthday: Date) {
	migrateUser(token: $token, id: $id, name: $name, password: $password, phone: $phone, email: $email, birthday: $birthday) 
}`;



/******************************
 * USER
 ******************************/

export const addUser = gql`
mutation addUser($name: String!, $password: String!) {
	addUser(name: $name, password: $password) { 
		id
		name 
	}
}`;

export const updateUser = gql`
mutation updateUser($id: ID!, $avatar: String, $description: String, $birthday: Date, $dateCreated: Date, $phone: String, $email: String, $oldpass: String, $oldid: Int) {
	updateUser(id: $id, avatar: $avatar, description: $description, birthday: $birthday, dateCreated: $dateCreated, phone: $phone, email: $email, oldpass: $oldpass, oldid: $oldid) { 
		id 
		name 
		avatar 
		description 
		email 
		phone 
	}
}`;

export const updateChannelView = gql`
mutation updateChannelView($id: ID!) {
	updateChannelView(id: $id)
}`;


/******************************
 * FILES
 ******************************/

export const deleteFile = gql`
mutation deleteFile($id: ID!) {
	deleteFile(id: $id) 
}`;

/******************************
 * CHANNEL
 ******************************/

export const addChannel = gql`
mutation addChannel($name: String!) {
	addChannel(name: $name) { id name }
}`;

export const updateChannel = gql`
mutation updateChannel($id: ID!, $name: String!) {
	updateChannel(id: $id, name: $name) { id name }
}`;

export const deleteChannel = gql`
mutation deleteChannel($id: ID!) {
	deleteChannel(id: $id)
}`;


/******************************
 * COMMENTS
 ******************************/

export const addComment = gql`
mutation addComment($channel: ID!, $parent: ID, $body: String!, $file: ID) {
	addComment(channel: $channel, parent: $parent, body: $body, file: $file) { id body }
}`;

export const updateComment = gql`
mutation updateComment($id: ID!, $body: String!) {
	updateComment(id: $id, body: $body) {
		id
		body
		weblinks {
			id
			url
			title
			alias
			image
			icon
		}
	}
}`;

export const deleteComment = gql`
mutation deleteComment($id: ID!) {
	deleteComment(id: $id) 
}`;

export const toggleVote = gql`
mutation toggleVote($post: ID!) {
	toggleVote(post: $post)
}`;


/******************************
 * NOTES
 ******************************/

export const addNote = gql`
mutation addNote($body: String!) {
	addNote(body: $body) {
		id
		body
	}
}`;

export const updateNote = gql`
mutation updateNote($id: ID!, $body: String!) {
	updateNote(id: $id, body: $body) {
		id
		body
	}
}`;

export const deleteNote = gql`
mutation deleteNote($id: ID!) {
	deleteNote(id: $id) 
}`;


/******************************
 * MAIL
 ******************************/

export const readMail = gql`
mutation readMail($id: ID!) {
	readMail(id: $id)
}`;

export const deleteMail = gql`
mutation deleteMail($id: ID!) {
	deleteMail(id: $id)
}`;

export const deleteAllMail = gql`
mutation deleteAllMail {
	deleteAllMail
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations.js